const isTrue = (val: any) => (val === true ? val : false);

export default isTrue;
